// extracted by mini-css-extract-plugin
module.exports = {"label":"Label__label--1mu","readOnly":"Label__readOnly--2a6","fieldLabelAsterisk":"Label__fieldLabelAsterisk--3fh","tooltipIcon":"Label__tooltipIcon--24s"};